import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getSettings, updateSettings } from './actionCreators';
import { initialState, SETTINGS_SLICE_NAME, SettingsState } from './models';

export const slice = createSlice({
  name: SETTINGS_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.fulfilled, (state: SettingsState, action) => {
        state.settings = action.payload.data;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateSettings.fulfilled, (state: SettingsState) => {
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(getSettings, updateSettings), (state: SettingsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getSettings, updateSettings), (state: SettingsState, action) => {
        const { error } = action;
        state.error = error;
        state.isLoading = false;

        showApiErrors(error);
      });
  },
});

export const { resetState } = slice.actions;

export default slice.reducer;
